export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14702.bbd2fe67.jpg";